import { Button, Grid } from "@mui/material";
import * as React from "react";
import { useEffect, useState } from "react";
import { useSelector } from "../../app/helpers";
import DepartmentCard from "./department-card.component";
import { useTranslation } from "react-i18next";
import AddDepartmentModal from "./add-department-modal.partial";
import { InfoIconWithTooltip } from "../../components/Title/InfoIcon";
import { RootState } from "../../app/rootReducer";
import { useRemoteGetAllCostCentersForCompany } from "../../hooks/Remote/Companies/useRemoteGetAllCostCentersForCompany";

export type Department = {
  id?: string;
  companyId: number;
  name: string;
  costCenterResponsibleMail?: string;
  active?: boolean;
  isDepartment?: boolean;
  userInfo?: {
    fullName: string;
    photo?: string | null;
  };
  description?: string;
};

const Departments = () => {
  const {
    userInformation: { companyId }
  } = useSelector((state: RootState) => state.login);

  const { t } = useTranslation();

  const [addDepartment, setAddDepartment] = useState(false);
  const [departments, setDepartments] = useState<Department[]>([]);

  const { data: remoteDepartments } = useRemoteGetAllCostCentersForCompany(companyId);

  useEffect(() => {
    if (!remoteDepartments) return;
    setDepartments(remoteDepartments);
  }, [remoteDepartments]);

  return (
    <React.Fragment>
      <div style={{ marginRight: 20 }}>
        <InfoIconWithTooltip tooltipText={t("_departmentInfo")} />
      </div>
      <Button onClick={() => setAddDepartment(true)} style={{ marginBottom: 10 }} color={"primary"}>
        {t("Add department")}
      </Button>
      <Grid container direction="row" justifyContent="flex-start" alignItems="flex-start">
        {departments.map(department => (
          <DepartmentCard
            key={department.id}
            departmentName={department.name}
            description={department.description}
            active={department.active}
            userInfo={department.userInfo}
            setDepartments={setDepartments}
            costCenterResponsibleMail={department.costCenterResponsibleMail || ""}
            companyId={department.companyId}
            isDepartment={department.isDepartment || false}
            id={department.id || ""}
          />
        ))}
      </Grid>
      <AddDepartmentModal
        open={addDepartment}
        setOpen={setAddDepartment}
        companyId={companyId}
        active={false}
        isDepartment={true}
        departmentName={""}
        setDepartments={setDepartments}
        id={""}
        description={""}
        userInfo={{ fullName: "", photo: null }}
        costCenterResponsibleMail={""}
      />
    </React.Fragment>
  );
};
export default Departments;
